import {useNavigate} from '@tanstack/react-router';

import { Page } from '@src/components/base';
import PlatformCarousel from '@src/components/PlatformCarousel.jsx';
import { useNavigateToTop } from '@src/hooks/useNavigateToTop';
import {AIAgentsSection} from '@src/pages/Home/AIAgentsSection.jsx';
import HeroSection from '@src/pages/Home/HeroSection';
import {IndustriesSection} from '@src/pages/Home/IndustriesSection.jsx';
import {IntegrationsSection} from '@src/pages/Home/IntegrationsSection.jsx';
import PlatformOverview from '@src/pages/Home/PlatformOverview.jsx';
import {ServicesSection} from '@src/pages/Home/ServicesSection.jsx';
import {StatsSection} from '@src/pages/Home/StatsSection.jsx';

function Home() {
  const navigate = useNavigate();
  const OnNavigate = (to) => navigate({ to });
  const onNavigateToTop = useNavigateToTop();
  return (
    <Page>
      <HeroSection onNavigate={OnNavigate} onNavigateToTop={onNavigateToTop} />
      <PlatformCarousel />
      <PlatformOverview onNavigate={OnNavigate} onNavigateToTop={onNavigateToTop} />
      <AIAgentsSection onNavigate={OnNavigate} onNavigateToTop={onNavigateToTop} />
      <StatsSection />
      <ServicesSection onNavigate={OnNavigate} onNavigateToTop={onNavigateToTop} />
      <IntegrationsSection onNavigate={OnNavigate} onNavigateToTop={onNavigateToTop} />
      <IndustriesSection onNavigate={OnNavigate} onNavigateToTop={onNavigateToTop} />
    </Page>
  );
}

Home.displayName = 'Home';
export default Home;
